<script setup lang="ts">
import { computed, onMounted } from 'vue';

import useContext from '@/composables/useContext';
import { setDefaultMeta } from '@/composables/useMeta';

import HeaderMarked from '@/components/HeaderMarked.vue';

const { page } = useContext();

const name = computed(() => {
  return page.value?.fields?._name;
});

const hideTitle = computed(() => {
  return page.value?.fields?.HideTitle;
});

const contentPageClass = computed(() => {
  return hideTitle.value
    ? 'content-page__content--gray'
    : 'content-page__content';
});

const blocks = computed(() => {
  return page.value?.blocks;
});

onMounted(() => {
  setDefaultMeta();
});

</script>

<template>
  <div class="content-page">
    <div :class="contentPageClass">
      <header-marked class="content-page__title" v-if="!hideTitle">{{
        name
      }}</header-marked>
      <blocks-repeater v-if="blocks" :blocks="blocks.Main" />
    </div>
  </div>
</template>

<style>
.content-page {
  display: flex;
  justify-content: center;
}

.content-page__content {
  background-color: #ebe5da;
  margin: 1rem;
  width: 100%;
  overflow: hidden;
  max-width: var(--site-max-width);
}

.content-page__content--gray {
  background-color: #ebe5da;
  margin: 0 1rem 1rem;
  width: 100%;
}

.content-page__title {
  font-size: 16px;
  padding: 2rem;
}

@media (--phone) {
  .content-page__content--gray {
    margin: 0;
  }
}

@media (--tabletAndDesktop) {
  .content-page__title {
    font-size: 22px;
    padding: 3rem;
  }
}
</style>
